<template>
	<div class="pa-2">
		<div class="d-flex justify-end mb-3">
			<input
				v-show="0"
				:value="fingerprintFile"
				accept=".dat"
				ref="fingerprint"
				type="file"
				@change="sendFingerprintsFile" />
			<v-btn
				:loading="loadingAddingFingerprint"
				:disabled="loadingAddingFingerprint"
				color="alt white--text"
				class="me-2"
				small
				@click="$refs.fingerprint.click()">
				<v-icon
					size="20"
					left>
					$add
				</v-icon>
				استيراد ملف البصمات
			</v-btn>
			<v-btn
				color="primary"
				small
				@click="showDialog = true">
				<v-icon
					size="20"
					left>
					$add
				</v-icon>
				إضافة جهاز
			</v-btn>
		</div>

		<bee-handy-table
			ref="table"
			:headers="headers"
			:items="items"
			:data-table-props="{ disableSort: true }"
			dense
			zebra
			fixed-header
			:height="$vuetify.breakpoint.height - 130"
			hide-default-footer
		>
			<template v-slot:item.actions="{}">
				<v-btn color="success" icon>
					<v-icon>
						mdi-swap-vertical-bold 
					</v-icon>
				</v-btn>
			</template>
		</bee-handy-table>

		<v-dialog
			v-model="showDialog"
			max-width="400px"
			transition="dialog-transition">
			<v-card elevation="3">
				<form>
					<v-card-title primary-title>
						إضافة جهاز بصمة
						<v-spacer></v-spacer>
						<v-btn
							@click="showDialog = false"
							icon>
							<v-icon color="alert-color">mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense>
							<v-col cols="12">
								<v-text-field
									outlined
									dense
									label="الاسم"
									hide-details></v-text-field>
							</v-col>
							<v-col cols="7">
								<v-text-field
									outlined
									dense
									label="host"
									hide-details></v-text-field>
							</v-col>
							<v-col cols="5">
								<v-text-field
									outlined
									dense
									label="port"
									hide-details></v-text-field>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions class="align-center">
						<v-spacer></v-spacer>
						<v-btn
							color="secondary"
							@click="showDialog = false">
							{{ $T('default-buttons.save') }}
						</v-btn>
					</v-card-actions>
				</form>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'FingerprintsDevices',

	data() {
		return {
			loadingAddingFingerprint: false,
			fingerprintFile: null,

			showDialog: false,

			headers: [
				{
					text: 'اسم الجهاز',
					value: 'name',
				},
				{
					text: 'تاريخ اخر استيراد',
					value: 'date',
				},
				{
					text: 'منذ',
					value: 'duration',
				},
				{
					text: 'عدد الاسطر المستوردة',
					value: 'rows',
				},
				{
					text: 'host',
					value: 'host',
				},
				{
					text: 'port',
					value: 'port',
				},
				{
					text: 'actions',
					name: 'actions',
					value: 'actions'
				}
			],

			items: [
				{
					name: 'جهاز البصمة 1',
					date: '2024-06-14',
					duration: '28 يوم',
					rows: '410',
					host: '192.168.20.25',
					port: '85',
				},
			],
		};
	},

	methods: {
		sendFingerprintsFile(e) {
			if (!e.target.files[0]) return;
			this.loadingAddingFingerprint = true;
			this.$store.dispatch('attendance/addFingerprint', { file: e.target.files[0] }).finally(() => {
				this.loadingAddingFingerprint = false;
			});
		},
	},
};
</script>

<style lang="scss" scoped></style>
